import React from 'react'
import styled from 'styled-components'

type BadgeVariant =
  | 'current'
  | 'future'
  | 'past'
  | 'buildingArea'
  | 'nonBuildingArea'
  | 'overlay'

interface StatusBadgeProps {
  variant: BadgeVariant
  label: string
}

const Badge = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.xsmall} ${theme.spacing.small}`};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  white-space: nowrap;

  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'current':
        return `
          background: ${theme.colors.successLight};
          color: #008A2E;
        `
      case 'future':
        return `
          background: ${theme.colors.primaryLight};
          color: ${theme.colors.primary};
        `
      case 'past':
        return `
          background: #F5F5F5;
          color: ${theme.colors.text.tertiary};
        `
      case 'buildingArea':
        return `
          background: ${theme.colors.successLight};
          color: #008A2E;
        `
      case 'nonBuildingArea':
        return `
          background: ${theme.colors.warningLight};
          color: #CC6B00;
        `
      case 'overlay':
        return `
          background: #E8E0FF;
          color: #6B00CC;
        `
      default:
        return `
          background: ${theme.colors.background.secondary};
          color: ${theme.colors.text.primary};
        `
    }
  }}
`

export const StatusBadge: React.FC<StatusBadgeProps> = ({ variant, label }) => {
  return <Badge $variant={variant}>{label}</Badge>
}
